import React from "react";
import "../App.css";

export default function Section({ id, kicker, title, children, right }) {
    return (
        <section className="section" id={id}>
        <div className="container">
            <div className="sectionHeader">
            <div>
                {kicker ? <div className="kicker">{kicker}</div> : null}
                <h2 className="h2">{title}</h2>
            </div>
            {right || null}
            </div>
            {children}
        </div>
        </section>
    );
}
